"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlayerPharmacyProduct = exports.isPharmacyCustomerProduct = exports.isPharmacyProduct = exports.isPharmacyMasterProduct = exports.PharmacySearchCriteria = exports.PharmacyProductProperty = exports.PharmacyPackageUnit = void 0;
/**
 * Unit opitons available when creating pharmacy master product from management-ui
 * Following units are used in PIM API products
 */
var PharmacyPackageUnit;
(function (PharmacyPackageUnit) {
    PharmacyPackageUnit["annos"] = "annos";
    PharmacyPackageUnit["annosta"] = "annosta";
    PharmacyPackageUnit["fol"] = "fol";
    PharmacyPackageUnit["g"] = "g";
    PharmacyPackageUnit["kapseli"] = "kapseli";
    PharmacyPackageUnit["kg"] = "kg";
    PharmacyPackageUnit["kpl"] = "kpl";
    PharmacyPackageUnit["l"] = "l";
    PharmacyPackageUnit["mg"] = "mg";
    PharmacyPackageUnit["ml"] = "ml";
    PharmacyPackageUnit["pari"] = "pari";
    PharmacyPackageUnit["rll"] = "rll";
    PharmacyPackageUnit["suihketta"] = "suihketta";
    PharmacyPackageUnit["tabletti"] = "tabletti";
})(PharmacyPackageUnit = exports.PharmacyPackageUnit || (exports.PharmacyPackageUnit = {}));
var PharmacyProductProperty;
(function (PharmacyProductProperty) {
    PharmacyProductProperty["description"] = "description";
    PharmacyProductProperty["ean"] = "ean";
    PharmacyProductProperty["marketer"] = "marketer";
    PharmacyProductProperty["name"] = "name";
    PharmacyProductProperty["normalComparisonString"] = "normalComparisonString";
    PharmacyProductProperty["packageUnit"] = "packageUnit";
    PharmacyProductProperty["packageMultiplier"] = "packageMultiplier";
    PharmacyProductProperty["packageSize"] = "packageSize";
    PharmacyProductProperty["price"] = "price";
    PharmacyProductProperty["vnr"] = "vnr";
})(PharmacyProductProperty = exports.PharmacyProductProperty || (exports.PharmacyProductProperty = {}));
/** Search criteria for Pharmacy product search */
var PharmacySearchCriteria;
(function (PharmacySearchCriteria) {
    /** EAN-code */
    PharmacySearchCriteria["ean"] = "ean";
    /** Product's name */
    PharmacySearchCriteria["name"] = "name";
    /** VNR-code */
    PharmacySearchCriteria["vnr"] = "vnr";
})(PharmacySearchCriteria = exports.PharmacySearchCriteria || (exports.PharmacySearchCriteria = {}));
/**
 * Typeguard for PharmacyMasterProduct
 */
exports.isPharmacyMasterProduct = (item) => (item === null || item === void 0 ? void 0 : item.ean) && (item === null || item === void 0 ? void 0 : item.vnr) && !item.customerId;
/**
 * Typeguard for PharmacyProduct
 */
exports.isPharmacyProduct = (item) => (item === null || item === void 0 ? void 0 : item.ean) && (item === null || item === void 0 ? void 0 : item.customerId) && (item === null || item === void 0 ? void 0 : item.name);
/**
 * Typeguard for PharmacyCustomerProduct
 */
exports.isPharmacyCustomerProduct = (item) => (item === null || item === void 0 ? void 0 : item.customerId) && (item === null || item === void 0 ? void 0 : item.ean) && !item.vnr;
/**
 * Typeguard for PharmacyProductPlayer
 */
exports.isPlayerPharmacyProduct = (item) => (item === null || item === void 0 ? void 0 : item.ean) && (item === null || item === void 0 ? void 0 : item.customerId) && (item === null || item === void 0 ? void 0 : item.name);
//# sourceMappingURL=productsPharmacy.js.map